import React from "react";
import { Link } from "gatsby";
import classnames from "classnames";
import Section from "../section/Section";
import Logo from "../../assets/Logo";
import Grid from "../grid/Grid";
import cssClass from "./Footer.module.scss";

const Footer = () => {
  return (
    <footer className={cssClass.footer}>
      <Section className={cssClass.footerLinksContainer}>
        <Grid columns={4}>
          <div className={cssClass.column}>
            <Link to="/">
              <Logo colorIcon />
            </Link>
            <address className={cssClass.addressText}>
              Helios Health
              <br />
              Friedrichstr. 136
              <br />
              10117 Berlin Germany
              <br />
              <a
                href="mailto:helioshealth@email.com"
                target="_blank"
                rel="noopener noreferrer"
                className={cssClass.emailAddress}
              >
                helioshealth@email.com
              </a>
            </address>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>Find your clinic</p>
            <ul
              className={classnames(cssClass.twoColumnList, cssClass.linkList)}
            >
              <li>
                <Link to="/">Madrid</Link>
              </li>
              <li>
                <Link to="/">Barcelona</Link>
              </li>
              <li>
                <Link to="/">Zaragoza</Link>
              </li>
              <li>
                <Link to="/">Vigo</Link>
              </li>
              <li>
                <Link to="/">Other cities</Link>
              </li>
            </ul>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>Understanding fertility</p>
            <ul
              className={classnames(cssClass.twoColumnList, cssClass.linkList)}
            >
              <li>
                <Link to="/">A</Link>
              </li>
              <li>
                <Link to="/">B</Link>
              </li>
              <li>
                <Link to="/">C</Link>
              </li>
              <li>
                <Link to="/">D</Link>
              </li>
              <li>
                <Link to="/">E</Link>
              </li>
              <li>
                <Link to="/">F</Link>
              </li>
            </ul>
          </div>
          <div className={cssClass.column}>
            <p className={cssClass.columnTitle}>Legal</p>
            <ul className={cssClass.linkList}>
              <li>
                <Link to="/">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/">Terms and conditions</Link>
              </li>
            </ul>
          </div>
        </Grid>
      </Section>
      <div className={cssClass.copyrightContainer}>
        <p>Copyright ⓒ Pineapple, ltd. {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
};

export default Footer;
